import { NavLink } from "react-router-dom";
import styles from "./CustomerSidebar.module.scss";
import { customerLinks } from "./data";

const CustomerSidebar = () => {
  return (
    <div className={styles.customer_sidebar}>
      <h3 className={styles.title}>My Account</h3>
      {customerLinks.map((link, index) => (
        <NavLink to={link.link} end key={index}>
          {({ isActive }) => (
            <div className={isActive ? styles.item_active : styles.item}>
              <img
                src={isActive ? link.img_active : link.img_inactive}
                width={20}
                height={20}
                alt={index}
              />
              <span className={styles.label}>{link.name}</span>
              {link.badges?.length > 0 && (
                <div className={styles.badges}>
                  {link.badges.map((badge, index) => (
                    <img src={badge} alt="badge" />
                  ))}
                </div>
              )}
            </div>
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default CustomerSidebar;
